module.exports = __webpack_public_path__ + "static/aspersores-e3389e0d04bbf372b3f091f40bc9b0fe.png";